import { startTestBox } from '@testboxlab/browser';
import { sentrySetup } from 'lib-shared-sentry';
import { useCallback } from 'react';

import { featureFlags } from 'utils/featureFlagging/featureFlags';

import { birdeatsbugService } from './scripts/birdeatsbug/birdeatsbug';
import { initTracking } from './scripts/tracking';
import {
  InitThirdPartyScriptsOptions,
  UseThirdPartyScriptsResult,
} from './useThirdPartyScripts.types';

export const useThirdPartyScripts = (): UseThirdPartyScriptsResult => {
  const init = useCallback(
    ({ user, organization, connectionId }: InitThirdPartyScriptsOptions) => {
      const { useBirdeatsbug } = featureFlags.get(['use-birdeatsbug']);

      initTracking({ user, organization });

      // Scripts below are loaded only in Production.
      if (!PRODUCTION) return;

      sentrySetup({ user, organization, connectionId });

      if (useBirdeatsbug) {
        birdeatsbugService.start();
        birdeatsbugService.loadUser(user);
      }

      if (organization.subdomain.startsWith('tbx-')) {
        try {
          startTestBox({});
        } catch (error) {
          console.error('TestBox threw an error: ', error);
        }
      }
    },
    [],
  );

  return init;
};
